export { default as HomepageHero } from './HomepageHero/HomepageHero';
export { default as TraditionalInstitutionalHero } from './TraditionalInstitutionalHero';
export { default as TwoColumnImageHero } from './TwoColumnImageHero';
export { default as QuizHero } from './QuizHero';
